import { matchPath, useLocation } from 'react-router-dom';
/**
 * Returns if user is restricted to switch the company based on restricted routes.
 * @returns isRestricted
 */
var useCompanyChangeRestricted = function () {
    var location = useLocation();
    var restrictedRoutes = [
        '/assets/serial-numbers/:id',
        '/training/chat-details/:conversationId/:userId',
        '/audit/chat-details/:conversationId/:userId',
        '/technicians/:id'
    ];
    var isRestricted = restrictedRoutes.some(function (route) { return matchPath(route, location.pathname); });
    return isRestricted;
};
export default useCompanyChangeRestricted;
